import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Per-instance overrides for a DynamicComponentElement's referenced
// component's variables. The raw value is a flat object keyed by
// variable id: `{ [varId]: <raw> }`. No compilation — each entry is
// handed to the relevant option class when the resolver picks it up.
// Hidden from the main inspector surface; the `DynamicComponentElement`
// inspector panel renders per-variable tools that write through this
// option directly.
export default class VariableOverrides extends BaseOption {
  static hideOptionTool = true;

  static userInterfaceComponent = {
    label: "Variable Overrides",
    component: inspectorTools.NONE,
    props: {},
  };

  static defaultValue = {};
}
